//封装本地存储存储数据与读取数据方法
//存储数据
export const SET_TOKEN = (token: string) => {
  localStorage.setItem('TOKEN', token);
};
//本地存储获取数据
export const GET_TOKEN = () => {
  return localStorage.getItem('TOKEN');
};
//本地存储删除数据方法
export const REMOVE_TOKEN = () => {
  localStorage.removeItem('TOKEN');
};
export const SET_REFRESHTOKEN = (refreshToken: string) => {
  localStorage.setItem('REFRESHTOKEN', refreshToken);
};
//本地存储获取数据
export const GET_REFRESHTOKEN = () => {
  return localStorage.getItem('REFRESHTOKEN');
};
//本地存储删除数据方法
export const REMOVE_REFRESHTOKEN = () => {
  localStorage.removeItem('REFRESHTOKEN');
};

export const SET_EXP = () => {
  const time = new Date();
  const timer = time.getTime() + 86400000;
  localStorage.setItem('EXP', timer.toString());
};

export const GET_EXP = () => {
  return localStorage.getItem('EXP');
};

export const REMOVE_EXP = () => {
  localStorage.removeItem('EXP');
};

export const SET_Division = (division: string[]) => {
  localStorage.setItem('DIVISION', JSON.stringify(division));
};

export const GET_Division = () => {
  const division = localStorage.getItem('DIVISION');
  return division ? JSON.parse(division) : [];
};

export const REMOVE_Division = () => {
  localStorage.removeItem('DIVISION');
};

